import { Typography, useTheme } from "@mui/material";
import { useEffect, useState } from "react";

const HeroText = ({
  texts = [],
  speed = 100,
  delayBetweenTexts = 1500,
  fadeOutDuration = 500,
}) => {
  const [textIndex, setTextIndex] = useState(0);
  const [visibleChars, setVisibleChars] = useState(0);
  const [fadingOut, setFadingOut] = useState(false);
  const [isReady, setIsReady] = useState(false);

  const currentText = texts[textIndex];
  const theme = useTheme();

  useEffect(() => {
    if (!currentText || fadingOut) return;

    if (visibleChars < currentText.length) {
      const timeout = setTimeout(() => {
        setVisibleChars((prev) => prev + 1);
      }, speed);
      return () => clearTimeout(timeout);
    } else {
      const delay = setTimeout(() => {
        setFadingOut(true);
      }, delayBetweenTexts);
      return () => clearTimeout(delay);
    }
  }, [visibleChars, currentText, texts, speed, delayBetweenTexts, fadingOut]);

  useEffect(() => {
    if (!fadingOut) return;

    const fadeTimeout = setTimeout(() => {
      setIsReady(false);
      setTextIndex((prev) => (prev + 1) % texts.length);
      setVisibleChars(0);
      setFadingOut(false);

      // Small delay before starting new text
      setTimeout(() => setIsReady(true), 50);
    }, fadeOutDuration);

    return () => clearTimeout(fadeTimeout);
  }, [fadingOut, texts.length, fadeOutDuration]);

  useEffect(() => {
    setIsReady(true);
  }, []);

  return (
    <Typography
      variant="h2"
      sx={{
        color: "white",
        lineHeight: 1.2,
        maxWidth: "57%",
        fontSize: "72px",
        [theme.breakpoints.between("lg", "xl")]: {
          fontSize: currentText === "Secured Business Loan" ? "58px" : "72px",
        },
      }}
      fontWeight={"600"}
      className={`typing-line ${fadingOut ? "fade-out" : ""} ${
        isReady ? "fade-in" : ""
      }`}
    >
      {[...currentText].map((char, index) => {
        return (
          <span
            key={index}
            className={`char ${index < visibleChars ? "visible" : ""}`}
          >
            {char === " " ? "\u00A0" : char}
          </span>
        );
      })}
    </Typography>
  );
};

export default HeroText;
